import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { adminApi } from "../../../../../../../services/Api/Admin/adminApi";
import { OrganizationApi } from "../../../../../../../services/Api/types";
import OrganizationAccessesForm from "./components/Form/OrganizationAccessesForm";

interface MatchParams {
	organizationId: string;
}

const AdminOrganizationsAccessesPage = () => {
	const [organization, setOrganization] = useState<OrganizationApi | undefined>();
	const { t } = useTranslation("admin");
	const { handleChangeTabTitle } = useBrowserTabTitle();
	const { addFlash } = useFlash();
	const history = useHistory();
	const { organizationId } = useParams<MatchParams>();

	useEffect(() => {
		fetchOrganization();
	}, []);

	const updateAccessesFormData = (data: OrganizationApi) => {
		setOrganization(data);
	};

	const fetchOrganization = async () => {
		try {
			const params = { include: "applications,applications.accesses,applications.properties,accesses" };
			const res = await adminApi.getAdminOrganization(Number(organizationId), params);
			setOrganization(res);
			handleChangeTabTitle(
				`${res.name} | ${t("modules.organization.field.accesses.title")} | ${t(
					"lib:go_component.navigation.admin"
				)}`
			);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!organization) {
		return <LoadingContainer />;
	}

	const goBack = () => {
		history.push(`/admin/organizations/${organization.id}`);
	};

	return (
		<div className="content">
			<Header back={goBack} title={`${t("modules.organization.field.accesses.title")} ${organization.name}`} />
			<OrganizationAccessesForm
				organization={organization}
				updateAccessesFormData={(data) => updateAccessesFormData(data)}
			/>
		</div>
	);
};
export default AdminOrganizationsAccessesPage;
